<template>
  <v-card
    v-if="customer"
    outlined
    class="mb-2"
  >
    <v-card-text class="pa-3">
      <div class="d-flex align-center justify-space-between mb-1">
        <div>
          <span class="text-subtitle-2 font-weight-bold">{{ customer.name }}</span>
          <span
            v-if="customer.memberNumber"
            class="text-caption ml-2 text--secondary"
          >(#{{ customer.memberNumber }})</span>
        </div>
        <v-btn
          icon
          small
          @click="$emit('remove')"
        >
          <v-icon small>
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <div class="d-flex flex-wrap gap-2 text-caption text--secondary">
        <span v-if="customer.birthday">
          <v-icon
            small
            class="mr-1"
          >{{ icons.mdiCakeVariant }}</v-icon>{{ customer.birthday }}
        </span>
        <span v-if="customer.visitCount !== undefined">
          来店{{ customer.visitCount }}回
        </span>
        <span v-if="customer.lastVisitedAt">
          前回{{ formatDate(customer.lastVisitedAt) }}
        </span>
      </div>

      <div
        v-if="customer.memo"
        class="text-caption mt-1"
      >
        {{ customer.memo }}
      </div>

      <div
        v-if="customer.notes && customer.notes.length > 0"
        class="mt-1"
      >
        <v-chip
          v-for="(note, idx) in customer.notes.slice(0, 3)"
          :key="idx"
          small
          class="mr-1 mb-1"
          :color="noteColor(note.category)"
          text-color="white"
        >
          {{ note.content }}
        </v-chip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiClose, mdiCakeVariant } from '@mdi/js'

export default {
  name: 'CustomerPreview',
  props: {
    customer: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      icons: { mdiClose, mdiCakeVariant },
    }
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      const m = d.getMonth() + 1
      const day = d.getDate()

      return `${m}/${day}`
    },
    noteColor(category) {
      const colors = {
        preference: 'blue',
        caution: 'red',
        conversation: 'green',
      }

      return colors[category] || 'grey'
    },
  },
}
</script>

<style scoped>
/* タブレット向け: Vuetifyのtext-caption(12px)をこの画面では読みやすいサイズに上書き */
.text-caption {
  font-size: 13px !important;
  font-weight: 500 !important;
}
</style>
